import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { GenerativeAIServiceTick } from "../../../../app-constants";

function Superchargelogistics() {
  return (
    <section
      className="supercharge_logistics p-100"
      style={{ background: "#FAFAFA" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Driving Innovation with ,<span>Cutting-Edge, In-Demand</span>{" "}
              Functionality
            </h2>
            <p>
              Our automotive app development company helps you integrate the
              most sought-after features designed to enhance user experience,
              optimize vehicle operations, and ensure seamless functionality.
              These features address the critical needs of businesses and
              consumers alike, ensuring your app remains competitive and
              impactful.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              // autoplay={false}
              spaceBetween={20}
              modules={[Autoplay]}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: 2,
                },
                1200: {
                  slidesPerView: 3,
                },
                1600: {
                  slidesPerView: 3,
                },
              }}
              className="logistics-slider"
            >
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Real-Time GPS Tracking</h5>
                    <p>
                      Accurate, live vehicle tracking for enhanced logistics
                      management and location monitoring.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>In-App Payments</h5>
                    <p>
                      Secure, integrated payment gateway for smooth and
                      trustworthy transactions.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Predictive Maintenance</h5>
                    <p>
                      AI-powered diagnostics to forecast vehicle maintenance
                      needs and reduce downtime.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Fleet Management Dashboard</h5>
                    <p>
                      Centralized dashboard to monitor, manage, and optimize
                      fleet performance in real time.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>User Authentication & Profiles</h5>
                    <p>
                      Personalized, secure user access and customizable profiles
                      for a tailored app experience.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Vehicle Health Monitoring</h5>
                    <p>
                      Track key vehicle metrics, from engine performance to fuel
                      efficiency, for proactive maintenance.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Route Optimization</h5>
                    <p>
                      Advanced route planning algorithms for faster,
                      fuel-efficient travel and deliveries.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Appointment Scheduling</h5>
                    <p>
                      Easy service appointment booking for repairs, inspections,
                      or routine maintenance.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>IoT Integration</h5>
                    <p>
                      Seamless connectivity with in-vehicle IoT devices for
                      enhanced control and automation.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="supercharge-slider-box">
                  <div className="icon">{GenerativeAIServiceTick}</div>
                  <div className="content">
                    <h5>Driver Behavior Analytics</h5>
                    <p>
                      Detailed insights into driving patterns and habits to
                      improve safety and reduce costs.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Superchargelogistics;
